module.exports = __webpack_public_path__ + "images/花筑般蓝pr长图_09.jpg?v=c9b8b08f";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/huazhu3/花筑般蓝pr长图_09.jpg
 ** module id = 66
 ** module chunks = 1 2
 **/